<template>
  <div class="container">
    <div class="glo_btnList" ref="btnList">
      <div class="glo_btnList_left">
        <el-button
          style="margin: 0 0 0 10px"
          class="glo_bg"
          size="small"
          @click="fetchWaybill"
          v-if="editable"
          >取出明细</el-button
        >
        <el-button
          style="margin: 0 0 0 10px"
          class="glo_bg"
          size="small"
          v-if="false"
          @click="showFetchOneWaybill = true"
          >单票添加运单</el-button
        >
        <el-button
          style="margin: 0 0 0 10px"
          class="glo_bg"
          size="small"
          @click="removeWaybill"
          v-if="editable"
          >移除</el-button
        >
      </div>
    </div>
    <!-- 表格 -->
    <mytable
      ref="mytable"
      :maxHeight="300"
      :tableData="tableData_1"
      :myTableHeard="myTableHeard"
      :isShowOperate="isShowOperate"
      :isShowMoreOperate="isShowMoreOperate"
      :btnsList="btnsList"
      :btnsMoreList="btnsMoreList"
      :Operatewidth="Operatewidth"
      :showFilter="false"
      :isselection="editable"
    >
      <template #transportPlanShow="{row}">
        <el-select v-model="row.transportPlan" @change="changeRow(row)" filterable>
          <el-option v-for="plan in transportPlans" :key="plan.planValue" :label="plan.planName" :value="plan.planValue"></el-option>
        </el-select>
      </template>
      <template #remarks="{row}">
        <el-input v-model="row.remarks" @change="changeRow(row)"></el-input>
      </template>
    </mytable>
    <paging
      ref="pags"
      :pageNum="pageStart"
      :total="pageCount"
      :size="pageTotal"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    ></paging>
    <myDialog
      diaWidth="1200px"
      dialogTitle="取出明细"
      :isShowDialog="showFetchWaybill"
      :showConfirm="true"
      @handleCloseDia="showFetchWaybill = false"
      @diaCancelBtn="showFetchWaybill = false"
      @diaConfirmBtn="handleCOnfirmWaybill"
      :isAppend="true"
    >
      <fetch-waybill :data="waybills" ref="waybillSelector" v-if="showFetchWaybill" :financeAssetAccountId="financeAssetAccountId"></fetch-waybill>
    </myDialog>
    <my-dialog
    diaWidth="400px"
      dialogTitle="单票添加运单"
      :isShowDialog="showFetchOneWaybill"
      :showConfirm="true"
      @handleCloseDia="showFetchOneWaybill = false"
      @diaCancelBtn="showFetchOneWaybill = false"
      @diaConfirmBtn="handleCOnfirmOneWaybill"
    >
      <el-form :model="fetchOneWaybill" label-width="60px" label-position="right">
        <el-form-item label="运单号" prop="waybillNumber">
          <el-input v-model="fetchOneWaybill.waybillNumber"></el-input>
        </el-form-item>
      </el-form>
    </my-dialog>
  </div>
</template>

<script>
import tableListNew from "@/pages/tableListNew.js"; //mixins 查询列表页公共方法
import sorttable from "@/components/sortTemplate.vue"; //自定义排序表头
import paging from "@/components/pagings.vue"; //分页组件
import mytable from "@/components/table/table.vue";
import myDialog from "@/components/Dialog.vue";
import FetchWaybill from "./FetchWaybill.vue";
export default {
  inject: ["reload"],
  mixins: [tableListNew],
  components: {
    sorttable,
    paging,
    mytable,
    myDialog,
    FetchWaybill,
  },
  props: {
    financeAssetAccountId:{
      type:String,
      default:''
    },
    allocationId:{
      type:String,
      default:''
    },
    readonly:{
      type:Boolean,
      default(){
        return false
      }
    }
  },
  data() {
    return {
      pageGroupName: "admin_allocation_record_fundflow_list_v5", //  页面标识
      reportFiledsNumber: "admin_allocation_record_fundflow_list_v5", // 动态 条件、表头
      isShowOperate: false, //是否显示右边操作
      isShowMoreOperate: false, //是否显示右边更多操作
      // 表格右边操作按钮
      btnsList: [
        {
          name: "修改", //按钮名称
          methods: "WaybillEdit", //当前页面的方法
          param: 1, //自定义参数标记
        },
        // {
        //   name: "删除",
        //   methods: "delBtns",
        //   param: "",
        // },
        {
          name: "详情",
          methods: "detail",
          param: 2,
        },
      ],
      // 表格右边更多的操作按钮
      btnsMoreList: [
        {
          name: "修改运单号",
          command: "updateNumber",
        },
        {
          name: "修改基本信息",
          command: "updateInfo",
        },
      ],
      //需要单独点击的列字段名数组
      fieldList: ["commandNumber"],
      Operatewidth: "220px", //操作列的列宽
      showFetchWaybill: false,
      waybills: [],
      tableData_1: [],
      showFetchOneWaybill:false,
      fetchOneWaybill:{
        waybillNumber:''
      },
      // myTableHeard:[
      //   {
      //     name:'流水号',
      //     field:'financeFundflowNumber',
      //     isShow:1,
      //     width:120
      //   },
      //   {
      //     name:'来源类型',
      //     field:'financeDocumentStatusName',
      //     isShow:1,
      //     width:120
      //   },
      //   {
      //     name:'来源单号',
      //     field:'financeDocumentNumber',
      //     isShow:1,
      //     width:120
      //   },
      //   {
      //     name:'收支类型',
      //     field:'inoutTypeName',
      //     isShow:1,
      //     width:120
      //   },
      //   {
      //     name:'资金账号名称',
      //     field:'fundAccountNumber',
      //     isShow:1,
      //     width:180
      //   },
      //   {
      //     name:'金额',
      //     field:'writeoffAmount',
      //     isShow:1,
      //     width:120
      //   },
      //   {
      //     name:'账号余额',
      //     field:'accountBalance',
      //     isShow:1,
      //     width:120
      //   },
      //   {
      //     name:'对账状态',
      //     field:'reconciliationTypeName',
      //     isShow:1,
      //     width:120
      //   },
      //   {
      //     name:'收支备注',
      //     field:'inoutComment',
      //     isShow:1,
      //     width:120
      //   },
      //   {
      //     name:'核销备注',
      //     field:'writeoffComment',
      //     isShow:1,
      //     width:120
      //   },
      //   {
      //     name:'新建时间',
      //     field:'createTime',
      //     isShow:1,
      //     width:180
      //   },
      //   {
      //     name:'操作人',
      //     field:'createUserName',
      //     isShow:1,
      //     width:120
      //   }
      // ],
    };
  },
  computed:{
    editable(){
      return !this.readonly
    }
  },
  async mounted() {
    // await this.getData({
    //   dispatchId: this.dispatchId,
    // });
    console.log(this.allocationId)
    if(this.allocationId){
      await this.getData({
        allocationId : this.allocationId
      })
    }
    this.tableData_1 = this.tableData.filter(
      (item) => item.operationType != "DEL"
    );
  },
  methods: {
    fetchWaybill() {
      if(!this.financeAssetAccountId){
        this.$message.warning('请选择转出账号')
        return
      }
      this.waybills = this.tableData_1.map(item=>item.id)
      this.showFetchWaybill = true;
    },
    handleCOnfirmWaybill() {
      this.showFetchWaybill = false;
      const rows = this.$refs.waybillSelector.getRows();
      const ids = this.tableData.map((item) => item.waybillSplitId);
      rows.map((item) => {
        if (!ids.includes(item.waybillSplitId)) {
          this.tableData.push({
            ...item,
            waybillRemarks:item.remarks,
            remarks:'',
            operationType: "ADD",
            // 默认选中第一行方案
            transportPlan: 'ru_cang:transport_plan'
          });
        }
      });
      this.tableData_1 = this.tableData.filter(
        (item) => item.operationType != "DEL"
      );
      this.$emit('calcAmount')
    },
    async handleCOnfirmOneWaybill(){
      const res = await this.$API.runList({
        number:'admin_waybill_list_v5',
        waybillNumberNoLike:this.fetchOneWaybill.waybillNumber
      })
      if(!res || res.length == 0){
        this.$message.error("找不到运单")
        return
      }
      const ids = this.tableData.map((item) => item.waybillSplitId);
      res.map((item) => {
        if (!ids.includes(item.waybillSplitId)) {
          this.tableData.push({
            ...item,
            waybillRemarks:item.remarks,
            remarks:'',
            operationType: "ADD",
            // 默认选中第一行方案
            transportPlan: this.transportPlans[0] && this.transportPlans[0].planValue,
          });
        }
      });
      this.tableData_1 = this.tableData.filter(
        (item) => item.operationType != "DEL"
      );
      this.showFetchOneWaybill = false
      this.fetchOneWaybill.waybillNumber = ''
      this.$emit('calcAmount')
    },
    removeWaybill() {
      this.selectTableData.map((item) => {
        if(item.operationType === 'ADD'){
          item.operationType = 'REMOVE'
        }else{
          item.operationType = 'DEL'
        }
      });
      this.$refs.mytable.clearSelection();
      this.tableData = this.tableData.filter(item=>item.operationType !== 'REMOVE')
      this.tableData_1 = this.tableData.filter(
        (item) => item.operationType != "DEL"
      );
      this.tableData = this.tableData_1
      this.$emit('calcAmount')
    },
    getRows() {
      return this.tableData.map((item, index) => {
        return {
          financeFundflowId:item.id,
          writeoffAmount:item.writeoffAmount,
          sort: index,
          operationType:item.operationType
        };
      });
    },
    changeRow(row){
      if(row.operationType !=='ADD'){
        row.operationType = 'UPDATE'
      }
    },
  },
};
</script>

<style lang="less" scoped>
.glo_btnList {
  margin-bottom: 10px;
}
</style> 